import {coachingApi, apiV2} from './api';
import {List} from 'immutable';
import Skill from 'records/Skill';
import cancelIfSending from 'sources/cancelIfSending';
import {Moment} from 'moment/moment';
import {UserId} from 'records/User';
import {TeamId} from 'records/TeamId';

const DATE_FORMAT = 'YYYY-MM-DD';

const SkillSource = {
  search(term, cancelConfig?) {
    const encodedTerm = encodeURIComponent(term);
    return apiV2
      .getJson(`/scorecard/skill/search/${encodedTerm}`, cancelConfig)
      .then(({skills}) => List(skills));
  },
  fetchAllUsed() {
    return coachingApi
      .getJson('/skills/used')
      .then(skills => List(skills.map(skill => new Skill(skill))));
  },
  fetchAllByTeam(params, cancelConfig?) {
    return coachingApi
      .getJson('/skills', {
        ...cancelConfig,
        params,
      })
      .then(skills => List(skills.map(skill => new Skill(skill))));
  },
  fetchUsedByDate(start: Moment, end: Moment, filter: TeamId[] | UserId) {
    const params = Array.isArray(filter) ? {teams: filter} : {userId: filter};
    return coachingApi
      .getJson('/skills/used/in-range', {
        params: {
          ...params,
          start: start.format(DATE_FORMAT),
          end: end.format(DATE_FORMAT),
        },
      })
      .then(skills => {
        return List(skills.map(skill => new Skill(skill)));
      });
  },
  fetchAverage(skillId, params, cancelConfig?) {
    return coachingApi.getJson(`/skills/${skillId}/averages`, {
      ...cancelConfig,
      params: {
        ...params,
        from: params.from.format(),
        to: params.to.format(),
      },
    });
  },
  fetchTeamTrend(params, cancelConfig?) {
    return coachingApi.getJson('/skills/team_trend', {
      ...cancelConfig,
      params: {
        ...params,
        from: params.from.format(),
        to: params.to.format(),
      },
    });
  },
  fetchUserTrend(params, cancelConfig?) {
    return coachingApi.getJson('/skills/user_trend', {
      ...cancelConfig,
      params: {
        ...params,
        from: params.from.format(),
        to: params.to.format(),
      },
    });
  },
};

export default SkillSource;
export const SkillCancellableSource = cancelIfSending(SkillSource);
